import { render } from "./EventCard.vue?vue&type=template&id=da68a918&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=da68a918&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-da68a918"

export default script